import Model from '@/models/Model.js';

export default class CourseSettings extends Model {
    static entity = 'course_settings';

    static fields() {
        return {
            id: this.attr(null),
            course_settings_template_id: this.attr(null),
            attendance_scenario_id: this.attr(null),
            start_date: this.attr(null),
            end_date: this.attr(null),
            grading_end_date: this.attr(null),
            enrollment_capacity: this.attr(null),
            course_key_enabled: this.boolean(false),
            exxat_course_id: this.attr(null),
            has_flexible_attendance: this.boolean(false),
            expected_scheduled_time: this.attr(null),
            course_authorized_role: this.attr(null),
            course_authorized_role_id: this.attr(null),
            show_student_enrollments: this.boolean(true),
            permit_extra_credit_overflow: this.boolean(false),
            is_pass_or_fail: this.boolean(true),
            issues_certificate: this.boolean(true),
            certificate_title: this.attr(null),
            certificate_approving_body: this.attr(null),
            certificate_credit_hours: this.attr(null),

            ...super.fields(),

            course: this.hasOne('courses', 'course_settings_id'),
            attendance_scenario: this.belongsTo('attendance_scenarios', 'attendance_scenario_id'),
            course_settings_template: this.belongsTo('course_settings_templates', 'course_settings_template_id'),
        };
    }
}
